/** Showcase workspace every company can open alongside its other workspaces. */

import { DEMO_WORKSPACE_NAME, DEMO_WORKSPACE_SLUG } from "@excellent/ui/verification-account";

export type SwitcherWorkspace = {
  id: number;
  slug: string;
  name: string;
};

export const DEMO_ORGANIZATION = {
  id: -1,
  slug: DEMO_WORKSPACE_SLUG,
  name: DEMO_WORKSPACE_NAME,
  kind: "demo" as const,
};

export const DEMO_ORG_HREF = "/";
export const REAL_ORG_HREF = "/";

export type OrganizationOption =
  (SwitcherWorkspace & { kind: "workspace" }) | typeof DEMO_ORGANIZATION;

export function organizationsForSwitcher(
  workspaces: readonly SwitcherWorkspace[],
): OrganizationOption[] {
  const real: OrganizationOption[] = workspaces
    .filter((workspace) => workspace.slug !== DEMO_WORKSPACE_SLUG)
    .map((workspace) => ({
      ...workspace,
      kind: "workspace" as const,
    }));
  return [...real, DEMO_ORGANIZATION];
}
